import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import {
  Building2,
  Plus,
  Edit,
  Trash2,
  Search,
  Save,
  Loader2,
  ArrowRightLeft,
  RefreshCw,
  DollarSign,
  FileText,
  Settings,
  CreditCard,
  Percent,
  Calculator,
  Filter,
  ChevronDown,
  ChevronUp,
  Landmark,
  ExternalLink,
  Eye,
  EyeOff,
  Copy,
  KeyRound,
  X
} from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";

// Dados iniciais para demonstração - Lista completa de bancos
const bancosIniciais = [
  { id: "1", codigo: "XXX", nome: "ADSEG", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "2", codigo: "121", nome: "AGIBANK S.A.", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "3", codigo: "934", nome: "AGIPLAN FINANCEIRA", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "4", codigo: ".", nome: "AKI CAPITAL", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "5", codigo: "025", nome: "ALFA", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "6", codigo: "003", nome: "AMAZÔNIA", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "7", codigo: "213", nome: "ARBI S.A.", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "8", codigo: "218", nome: "BANCO BONSUCESSO", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "9", codigo: "779", nome: "BANCO INTERMEDIUM", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "10", codigo: "XXX", nome: "BANCO NÃO PARCEIRO", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "11", codigo: "756", nome: "BANCOOB", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "12", codigo: "037", nome: "BANPARA", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "13", codigo: "041", nome: "BANRISUL", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "14", codigo: "330", nome: "BARI S.A", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "15", codigo: "914", nome: "BARIGUI", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "16", codigo: "XXX", nome: "BCV", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "17", codigo: "XXX", nome: "BIC BANCO", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "18", codigo: "901", nome: "BICBANC_CCB BRASIL_CFI_SUL FINANCEIRA", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "19", codigo: "318", nome: "BMG", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "20", codigo: "069", nome: "BPN BRASIL BANCO MULTIPLO", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "21", codigo: "237", nome: "BRADESCO S A", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "22", codigo: "001", nome: "BRASIL", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "23", codigo: "070", nome: "BRB CREDITO FINAN. E INVEST", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "24", codigo: "655", nome: "BV", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "25", codigo: "626", nome: "C6 FICSA", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "26", codigo: "263", nome: "CACIQUE", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "27", codigo: "104", nome: "CAIXA", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "28", codigo: "XXX", nome: "CAPEMI", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "29", codigo: "929", nome: "CBSS S.A", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "30", codigo: "739", nome: "CETELEN", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "31", codigo: "320", nome: "CHINA CONSTRUCTION BANK", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "32", codigo: "XXX", nome: "CIASPREV", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "33", codigo: "XXX", nome: "CIFRA", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "34", codigo: "XXX", nome: "CLICKBANK", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "35", codigo: "730", nome: "COMPREV - EMPREST PREV PRIVADA", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "36", codigo: "902", nome: "COOPERATIVA CENTRAL DE ECONOMIA E CRÉDITO MUTUO - SICOOB UNIMAIS", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "37", codigo: "921", nome: "CREDIARE", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "38", codigo: "69", nome: "CREFISA S.A", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "39", codigo: "229", nome: "CRUZEIRO DO SUL", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "40", codigo: "707", nome: "DAYCOVAL", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "41", codigo: "394", nome: "DIGIO_BRADESCO FIN", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "42", codigo: "954", nome: "DIGIO_CBSS", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "43", codigo: "742", nome: "EQUATORIAL", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "44", codigo: "149", nome: "FACTA FINANCEIRA", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "45", codigo: "XXX", nome: "FHE - POUPEX", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "46", codigo: "905", nome: "FINANCEIRA ALFA S A", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "47", codigo: ".", nome: "FINTECH CORBAN STILO", parceiro: false, consignado: true, srt: true, seguro: false, cartao: false, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "48", codigo: ".", nome: "FY DIGITAL", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "49", codigo: "233", nome: "GE", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "50", codigo: "121", nome: "GERADOR", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "51", codigo: ".", nome: "HAPPY", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "52", codigo: "399", nome: "HSBC", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "53", codigo: "063", nome: "IBI (BRADESCARD) MULTIPLOS", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "54", codigo: "012", nome: "INBURSA", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "55", codigo: "604", nome: "INDUSTRIAL DO BRASIL", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "56", codigo: "077", nome: "INTERMEDIUM", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "57", codigo: "029", nome: "ITAU CONSIGNADO S.A", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "58", codigo: "341", nome: "ITAU SA", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "59", codigo: "XXX", nome: "LUSO BRASILEIRO", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "60", codigo: "243", nome: "MASTER", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "61", codigo: "212", nome: "MATONE", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "62", codigo: "243", nome: "MAXIMA S.A", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "63", codigo: "389", nome: "MERCANTIL DO BRASIL", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "64", codigo: "000", nome: "NAO LOCALIZADO", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "65", codigo: ".", nome: "NEO CREDITO", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "66", codigo: "260", nome: "NUBANK_NU PAGAMENTOS S.A", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "67", codigo: "955", nome: "OLE BONSUCESSO", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "68", codigo: "212", nome: "ORIGINAL S A", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "69", codigo: "290", nome: "PAGBANK", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "70", codigo: "623", nome: "PAN", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "71", codigo: "254", nome: "PARANA BANCO S. A.", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "72", codigo: "908", nome: "PARATI CFI SA", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "73", codigo: "611", nome: "PAULISTA S.A", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "74", codigo: "XXX", nome: "PEG CARD", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "75", codigo: "380", nome: "PICPAY", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "76", codigo: "643", nome: "PINE", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "77", codigo: ".", nome: "PREV. EQUATORIAL", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "78", codigo: ".", nome: "PREVIK ASSOCIAÇÃO", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "79", codigo: "XXX", nome: "PREVIMIL", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "80", codigo: "465", nome: "QUERO MAIS CREDITO - CAPITAL CONSIG", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "81", codigo: "356", nome: "REAL", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "82", codigo: "453", nome: "RURAL_RSPP", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "83", codigo: "1000", nome: "SABEMI", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "84", codigo: "422", nome: "SAFRA", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "85", codigo: "033", nome: "SANTANDER", parceiro: false, consignado: true, srt: true, seguro: false, cartao: true, refin: true, portabilidade: true, esteira: true, saqueFgts: true, emprestimoClt: false },
  { id: "86", codigo: "250", nome: "SCHAHIN", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "87", codigo: "081", nome: "SEGURO SA", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "88", codigo: "XXX", nome: "SEMEAR", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "89", codigo: "748", nome: "SICREDI", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "90", codigo: "SC", nome: "STILOCRED", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "91", codigo: "901", nome: "SUL FINANCEIRA", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
  { id: "92", codigo: "359", nome: "ZEMA CFI SA", parceiro: false, consignado: false, srt: false, seguro: false, cartao: false, refin: false, portabilidade: false, esteira: false, saqueFgts: false, emprestimoClt: false },
];

const parametrosPortabilidadeIniciais = [
  { id: "1", banco: "001 - BANCO DO BRASIL", instituicao: "INSS", idadeMin: 21, idadeMax: 80, parcelasPagas: 7, valorParcelaMin: 50, saldoDevedorMin: 500, valorTroco: 100, valorRco: 50, indice1_30: 0.95, indice31_50: 0.90, indice51_100: 0.85 },
  { id: "2", banco: "104 - CAIXA ECONÔMICA", instituicao: "INSS", idadeMin: 21, idadeMax: 80, parcelasPagas: 6, valorParcelaMin: 40, saldoDevedorMin: 400, valorTroco: 80, valorRco: 40, indice1_30: 0.93, indice31_50: 0.88, indice51_100: 0.83 },
  { id: "3", banco: "237 - BRADESCO", instituicao: "SIAPE", idadeMin: 18, idadeMax: 75, parcelasPagas: 5, valorParcelaMin: 60, saldoDevedorMin: 600, valorTroco: 120, valorRco: 60, indice1_30: 0.94, indice31_50: 0.89, indice51_100: 0.84 },
];

const linhasFinanciamentoIniciais = [
  { id: "1", banco: "001 - BANCO DO BRASIL", instituicao: "INSS", tipo: "EMPRÉSTIMO", obrigMonitorar: true, documentacao: "RG, CPF, Comprovante de Residência" },
  { id: "2", banco: "001 - BANCO DO BRASIL", instituicao: "INSS", tipo: "CARTÃO CONSIGNADO", obrigMonitorar: true, documentacao: "RG, CPF" },
  { id: "3", banco: "001 - BANCO DO BRASIL", instituicao: "SIAPE", tipo: "EMPRÉSTIMO", obrigMonitorar: true, documentacao: "RG, CPF, Contracheque" },
  { id: "4", banco: "104 - CAIXA ECONÔMICA", instituicao: "INSS", tipo: "EMPRÉSTIMO", obrigMonitorar: true, documentacao: "RG, CPF, Comprovante de Residência" },
  { id: "5", banco: "104 - CAIXA ECONÔMICA", instituicao: "INSS", tipo: "PORTABILIDADE", obrigMonitorar: false, documentacao: "RG, CPF, Extrato do Contrato Original" },
];

const parametrosRefinIniciais = [
  { id: "1", banco: "001 - BANCO DO BRASIL", instituicao: "INSS", idadeMin: 21, idadeMax: 80, parcelasPagas: 12, valorParcelaMin: 100, saldoDevedorMin: 1000, trocoMin: 30, trocoMax: 70, taxaJuros: 1.80 },
  { id: "2", banco: "104 - CAIXA ECONÔMICA", instituicao: "INSS", idadeMin: 21, idadeMax: 80, parcelasPagas: 10, valorParcelaMin: 80, saldoDevedorMin: 800, trocoMin: 25, trocoMax: 65, taxaJuros: 1.75 },
  { id: "3", banco: "237 - BRADESCO", instituicao: "SIAPE", idadeMin: 18, idadeMax: 75, parcelasPagas: 8, valorParcelaMin: 120, saldoDevedorMin: 1200, trocoMin: 35, trocoMax: 75, taxaJuros: 1.90 },
];

const comissoesIniciais = [
  { id: "1", banco: "001 - BANCO DO BRASIL", instituicao: "INSS", tipo: "EMPRÉSTIMO", empresa: 8.0, teleVenda: 2.5, corretor: 3.0, atendente: 1.0, gerAdm: 0.5, gerOper: 1.0 },
  { id: "2", banco: "001 - BANCO DO BRASIL", instituicao: "INSS", tipo: "CARTÃO", empresa: 5.0, teleVenda: 1.5, corretor: 2.0, atendente: 0.5, gerAdm: 0.3, gerOper: 0.7 },
  { id: "3", banco: "001 - BANCO DO BRASIL", instituicao: "SIAPE", tipo: "EMPRÉSTIMO", empresa: 7.5, teleVenda: 2.0, corretor: 2.5, atendente: 0.8, gerAdm: 0.4, gerOper: 0.8 },
  { id: "4", banco: "104 - CAIXA ECONÔMICA", instituicao: "INSS", tipo: "EMPRÉSTIMO", empresa: 7.0, teleVenda: 2.0, corretor: 2.5, atendente: 0.8, gerAdm: 0.4, gerOper: 0.8 },
];

const regrasOperacionaisIniciais = [
  { id: "1", banco: "001 - BANCO DO BRASIL", instituicao: "INSS", regra: "Prazo máximo de averbação", valor: "5 dias úteis", ativo: true },
  { id: "2", banco: "001 - BANCO DO BRASIL", instituicao: "INSS", regra: "Horário de operação", valor: "08:00 às 20:00", ativo: true },
  { id: "3", banco: "001 - BANCO DO BRASIL", instituicao: "SIAPE", regra: "Margem consignável", valor: "35%", ativo: true },
  { id: "4", banco: "104 - CAIXA ECONÔMICA", instituicao: "INSS", regra: "Prazo máximo de averbação", valor: "3 dias úteis", ativo: true },
  { id: "5", banco: "104 - CAIXA ECONÔMICA", instituicao: "INSS", regra: "Quantidade máxima de contratos", valor: "9 contratos", ativo: true },
  { id: "6", banco: "237 - BRADESCO", instituicao: "SIAPE", regra: "Carência mínima", valor: "30 dias", ativo: false },
];

export default function Bancos() {
  const [activeTab, setActiveTab] = useState("bancos");
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleteModule, setDeleteModule] = useState("");
  const navigate = useNavigate();
  
  // Estados para cada módulo
  const [bancos, setBancos] = useState([]);
  const [parametrosPortabilidade, setParametrosPortabilidade] = useState(parametrosPortabilidadeIniciais);
  const [linhasFinanciamento, setLinhasFinanciamento] = useState(linhasFinanciamentoIniciais);
  const [parametrosRefin, setParametrosRefin] = useState(parametrosRefinIniciais);
  const [comissoes, setComissoes] = useState(comissoesIniciais);
  const [regrasOperacionais, setRegrasOperacionais] = useState(regrasOperacionaisIniciais);
  
  // Estados para dialogs
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [currentModule, setCurrentModule] = useState("");

  // Filtros
  const [filtroBanco, setFiltroBanco] = useState("");
  const [filtroInstituicao, setFiltroInstituicao] = useState("");
  const [filtroNomeBanco, setFiltroNomeBanco] = useState("");
  const [filtroCaracteristica, setFiltroCaracteristica] = useState("todos"); // Novo filtro por característica
  const [showSenhaAcesso, setShowSenhaAcesso] = useState({});

  // Estados para aba Instituições (órgãos/convênios)
  const [instAcessoList, setInstAcessoList] = useState([]);
  const [instAcessoDialogOpen, setInstAcessoDialogOpen] = useState(false);
  const [instAcessoEditando, setInstAcessoEditando] = useState(null);
  const [instAcessoForm, setInstAcessoForm] = useState({ nome: "", url: "", usuario: "", senha: "", observacoes: "" });
  const [showSenhaInst, setShowSenhaInst] = useState({});
  const [loadingInstAcesso, setLoadingInstAcesso] = useState(false);

  // Estados para modal de instituições
  const [instituicoesDialogOpen, setInstituicoesDialogOpen] = useState(false);
  const [bancoSelecionadoInst, setBancoSelecionadoInst] = useState(null);
  const [instituicoesVinculadas, setInstituicoesVinculadas] = useState([]);
  const [todasInstituicoes, setTodasInstituicoes] = useState([]);
  const [loadingInstituicoes, setLoadingInstituicoes] = useState(false);

  // Carregar bancos da API
  useEffect(() => {
    carregarBancos();
    carregarTodasInstituicoes();
    carregarInstAcesso();
  }, []);

  // Carregar todas as instituições disponíveis
  const carregarTodasInstituicoes = async () => {
    try {
      const response = await axios.get(`${API}/lookup/instituicoes`);
      const instituicoes = response.data?.instituicoes || [];
      // Processar para garantir formato {codigo, nome}
      const processadas = instituicoes.map(inst => {
        if (typeof inst === 'string') {
          const parts = inst.split(' - ');
          return { codigo: parts[0]?.trim(), nome: parts[1]?.trim() || parts[0] };
        }
        return inst;
      });
      setTodasInstituicoes(processadas);
    } catch (error) {
      console.error("Erro ao carregar instituições:", error);
    }
  };

  const carregarBancos = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/bancos`);
      if (response.data && response.data.length > 0) {
        setBancos(response.data);
      } else {
        await axios.post(`${API}/bancos/inicializar`);
        const response2 = await axios.get(`${API}/bancos`);
        setBancos(response2.data || bancosIniciais);
      }
    } catch (error) {
      console.error("Erro ao carregar bancos:", error);
      setBancos(bancosIniciais);
    } finally {
      setLoading(false);
    }
  };

  // CRUD Instituições Acesso (órgãos/convênios)
  const carregarInstAcesso = async () => {
    try {
      const response = await axios.get(`${API}/instituicoes-acesso`);
      setInstAcessoList(response.data || []);
    } catch (error) {
      console.error("Erro ao carregar instituições acesso:", error);
    }
  };

  const salvarInstAcesso = async () => {
    if (!instAcessoForm.nome?.trim()) {
      toast.error("Nome da instituição é obrigatório");
      return;
    }
    setLoadingInstAcesso(true);
    try {
      if (instAcessoEditando) {
        await axios.put(`${API}/instituicoes-acesso/${instAcessoEditando.id}`, instAcessoForm);
        toast.success("Instituição atualizada com sucesso");
      } else {
        await axios.post(`${API}/instituicoes-acesso`, instAcessoForm);
        toast.success("Instituição criada com sucesso");
      }
      setInstAcessoDialogOpen(false);
      setInstAcessoEditando(null);
      setInstAcessoForm({ nome: "", url: "", usuario: "", senha: "", observacoes: "" });
      carregarInstAcesso();
    } catch (error) {
      toast.error("Erro ao salvar instituição");
      console.error(error);
    } finally {
      setLoadingInstAcesso(false);
    }
  };

  const abrirEditarInstAcesso = (item) => {
    setInstAcessoEditando(item);
    setInstAcessoForm({ nome: item.nome || "", url: item.url || "", usuario: item.usuario || "", senha: item.senha || "", observacoes: item.observacoes || "" });
    setInstAcessoDialogOpen(true);
  };

  const abrirNovaInstAcesso = () => {
    setInstAcessoEditando(null);
    setInstAcessoForm({ nome: "", url: "", usuario: "", senha: "", observacoes: "" });
    setInstAcessoDialogOpen(true);
  };

  const excluirInstAcesso = async (item) => {
    if (!window.confirm(`Excluir "${item.nome}"?`)) return;
    try {
      await axios.delete(`${API}/instituicoes-acesso/${item.id}`);
      toast.success("Instituição excluída");
      carregarInstAcesso();
    } catch (error) {
      toast.error("Erro ao excluir");
      console.error(error);
    }
  };

  const filtrarInstAcesso = () => {
    if (!filtroNomeBanco) return instAcessoList;
    return instAcessoList.filter(i => i.nome?.toLowerCase().includes(filtroNomeBanco.toLowerCase()));
  };

  // Função para filtrar dados
  const filtrarDados = (dados) => {
    return dados.filter(item => {
      const matchBanco = !filtroBanco || item.banco?.includes(filtroBanco);
      const matchInstituicao = !filtroInstituicao || item.instituicao?.includes(filtroInstituicao);
      return matchBanco && matchInstituicao;
    });
  };

  // Função para filtrar bancos por nome e característica
  const filtrarBancos = () => {
    let resultado = bancos;
    
    // Filtrar por nome/código
    if (filtroNomeBanco) {
      resultado = resultado.filter(b => 
        b.nome.toLowerCase().includes(filtroNomeBanco.toLowerCase()) ||
        b.codigo.toLowerCase().includes(filtroNomeBanco.toLowerCase())
      );
    }
    
    // Filtrar por característica
    if (filtroCaracteristica && filtroCaracteristica !== "todos" && filtroCaracteristica !== "linkacesso") {
      resultado = resultado.filter(b => b[filtroCaracteristica] === true);
    }
    
    return resultado;
  };

  // Contar bancos por característica
  const contarPorCaracteristica = (campo) => {
    return bancos.filter(b => b[campo] === true).length;
  };

  // Função para confirmar exclusão
  const confirmarExclusao = (item, modulo) => {
    setItemToDelete(item);
    setDeleteModule(modulo);
    setDeleteDialogOpen(true);
  };

  // Função para excluir item
  const excluirItem = async () => {
    if (!itemToDelete || !deleteModule) return;

    try {
      switch (deleteModule) {
        case 'bancos':
          await axios.delete(`${API}/bancos/${itemToDelete.id}`);
          setBancos(prev => prev.filter(b => b.id !== itemToDelete.id));
          toast.success(`Banco "${itemToDelete.nome}" excluído com sucesso`);
          break;
        case 'portabilidade':
          setParametrosPortabilidade(prev => prev.filter(p => p.id !== itemToDelete.id));
          toast.success("Parâmetro de portabilidade excluído com sucesso");
          break;
        case 'linhas':
          setLinhasFinanciamento(prev => prev.filter(l => l.id !== itemToDelete.id));
          toast.success("Linha de financiamento excluída com sucesso");
          break;
        case 'refin':
          setParametrosRefin(prev => prev.filter(r => r.id !== itemToDelete.id));
          toast.success("Parâmetro de refin excluído com sucesso");
          break;
        case 'comissoes':
          setComissoes(prev => prev.filter(c => c.id !== itemToDelete.id));
          toast.success("Comissão excluída com sucesso");
          break;
        case 'regras':
          setRegrasOperacionais(prev => prev.filter(r => r.id !== itemToDelete.id));
          toast.success("Regra operacional excluída com sucesso");
          break;
        default:
          break;
      }
    } catch (error) {
      toast.error("Erro ao excluir item");
      console.error(error);
    }

    setDeleteDialogOpen(false);
    setItemToDelete(null);
    setDeleteModule("");
  };

  // Estado para edição de banco
  const [editBancoDialogOpen, setEditBancoDialogOpen] = useState(false);
  const [bancoEditando, setBancoEditando] = useState(null);

  // Função para abrir página de edição do banco
  const abrirEdicaoBanco = (banco) => {
    navigate(`/bancos/${banco.id}/editar`);
  };

  const abrirLinkAcesso = (link) => {
    if (!link) return;
    const url = link.startsWith("http") ? link : `https://${link}`;
    window.open(url, "_blank");
  };
  const copiarTexto = (txt) => {
    if (!txt) return;
    if (navigator.clipboard) { navigator.clipboard.writeText(txt).then(() => toast.success("Copiado!")).catch(() => {}); }
  };
  const temAcessos = (b) => (b.acessos || []).some(a => a && (a.link || a.usuario || a.correspondente || a.senha));

  // Função para salvar edição do banco
  const salvarEdicaoBanco = () => {
    if (!bancoEditando) return;
    
    setBancos(prev => prev.map(b => 
      b.id === bancoEditando.id ? bancoEditando : b
    ));
    
    toast.success(`Banco "${bancoEditando.nome}" atualizado com sucesso`);
    setEditBancoDialogOpen(false);
    setBancoEditando(null);
  };

  // Toggle checkbox para bancos - COM SALVAMENTO AUTOMÁTICO NA API
  const toggleBancoCheckbox = async (bancoId, field) => {
    // Atualizar estado local imediatamente (otimista)
    const bancoAtual = bancos.find(b => b.id === bancoId);
    const novoValor = !bancoAtual[field];
    
    setBancos(prev => prev.map(b => 
      b.id === bancoId ? { ...b, [field]: novoValor } : b
    ));
    
    try {
      // Salvar na API usando PATCH (atualização parcial)
      await axios.patch(`${API}/bancos/${bancoId}`, { [field]: novoValor });
      toast.success(`${field === 'parceiro' ? 'Parceiro' : 
        field === 'consignado' ? 'Crédito Pessoal' :
        field === 'srt' ? 'DBT' :
        field === 'seguro' ? 'Seguro' :
        field === 'cartao' ? 'Cartão' :
        field === 'refin' ? 'Refin' :
        field === 'portabilidade' ? 'Portabilidade' :
        field === 'esteira' ? 'Nova Margem' :
        field === 'saqueFgts' ? 'Saque FGTS' :
        field === 'emprestimoClt' ? 'Emp. CLT' : field
      } ${novoValor ? 'ativado' : 'desativado'} para ${bancoAtual.nome}`);
    } catch (error) {
      // Reverter em caso de erro
      setBancos(prev => prev.map(b => 
        b.id === bancoId ? { ...b, [field]: !novoValor } : b
      ));
      toast.error("Erro ao salvar. Tente novamente.");
      console.error("Erro ao atualizar banco:", error);
    }
  };

  // Toggle regra operacional
  const toggleRegraAtiva = (regraId) => {
    setRegrasOperacionais(prev => prev.map(r => 
      r.id === regraId ? { ...r, ativo: !r.ativo } : r
    ));
    toast.success("Regra atualizada");
  };

  // Abrir modal de instituições para um banco
  const abrirModalInstituicoes = (banco) => {
    setBancoSelecionadoInst(banco);
    // Garantir que instituicoes é um array
    const instituicoesAtuais = banco.instituicoes || [];
    setInstituicoesVinculadas(instituicoesAtuais);
    setInstituicoesDialogOpen(true);
  };

  // Adicionar instituição ao banco
  const adicionarInstituicao = async (instituicaoCodigo) => {
    if (!bancoSelecionadoInst || instituicoesVinculadas.includes(instituicaoCodigo)) return;
    
    setLoadingInstituicoes(true);
    try {
      await axios.post(`${API}/bancos/${bancoSelecionadoInst.id}/instituicoes`, {
        instituicao_codigo: instituicaoCodigo
      });
      
      // Atualizar estado local
      const novasInstituicoes = [...instituicoesVinculadas, instituicaoCodigo];
      setInstituicoesVinculadas(novasInstituicoes);
      
      // Atualizar o banco na lista
      setBancos(prev => prev.map(b => 
        b.id === bancoSelecionadoInst.id ? { ...b, instituicoes: novasInstituicoes } : b
      ));
      
      const inst = todasInstituicoes.find(i => i.codigo === instituicaoCodigo);
      toast.success(`${inst?.nome || instituicaoCodigo} adicionada ao ${bancoSelecionadoInst.nome}`);
    } catch (error) {
      toast.error("Erro ao adicionar instituição");
      console.error(error);
    } finally {
      setLoadingInstituicoes(false);
    }
  };

  // Remover instituição do banco
  const removerInstituicao = async (instituicaoCodigo) => {
    if (!bancoSelecionadoInst) return;
    
    setLoadingInstituicoes(true);
    try {
      await axios.delete(`${API}/bancos/${bancoSelecionadoInst.id}/instituicoes/${instituicaoCodigo}`);
      
      // Atualizar estado local
      const novasInstituicoes = instituicoesVinculadas.filter(i => i !== instituicaoCodigo);
      setInstituicoesVinculadas(novasInstituicoes);
      
      // Atualizar o banco na lista
      setBancos(prev => prev.map(b => 
        b.id === bancoSelecionadoInst.id ? { ...b, instituicoes: novasInstituicoes } : b
      ));
      
      const inst = todasInstituicoes.find(i => i.codigo === instituicaoCodigo);
      toast.success(`${inst?.nome || instituicaoCodigo} removida do ${bancoSelecionadoInst.nome}`);
    } catch (error) {
      toast.error("Erro ao remover instituição");
      console.error(error);
    } finally {
      setLoadingInstituicoes(false);
    }
  };

  // Obter nome da instituição pelo código
  const getNomeInstituicao = (codigo) => {
    const inst = todasInstituicoes.find(i => i.codigo === codigo);
    return inst?.nome || codigo;
  };

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
            <Building2 className="h-6 w-6 text-blue-600" />
            Ambiente de Bancos
          </h1>
          <p className="text-muted-foreground">Gerenciamento de bancos, parâmetros e comissões</p>
        </div>
      </div>

      {/* Área principal sem tabs */}
      <Card>
        <CardContent className="pt-6">
          {/* Header com filtros e botão */}
          <div className="flex flex-col gap-3 mb-4">
            {/* Linha 1: Campo de busca + Botão Novo Banco */}
            <div className="flex items-center gap-4">
              <div className="relative flex-1 max-w-md">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input
                  placeholder={filtroCaracteristica === "instituicoes" ? "Buscar instituição..." : "Buscar por nome ou código..."}
                  value={filtroNomeBanco}
                  onChange={(e) => setFiltroNomeBanco(e.target.value)}
                  className="pl-10"
                  data-testid="search-input"
                />
              </div>
              {filtroNomeBanco && (
                <Button variant="ghost" size="sm" onClick={() => setFiltroNomeBanco("")}>
                  Limpar
                </Button>
              )}
              <span className="text-sm text-muted-foreground">
                {filtroCaracteristica === "instituicoes"
                  ? `${filtrarInstAcesso().length} de ${instAcessoList.length} instituições`
                  : `${filtrarBancos().length} de ${bancos.length} bancos`}
              </span>
              {filtroCaracteristica === "instituicoes" ? (
                <Button className="gap-2 bg-emerald-600 hover:bg-emerald-700 ml-auto" onClick={abrirNovaInstAcesso} data-testid="btn-nova-instituicao">
                  <Plus className="h-4 w-4" />
                  Nova Instituição
                </Button>
              ) : (
                <Button className="gap-2 bg-blue-600 hover:bg-blue-700 ml-auto" onClick={() => navigate("/bancos/novo")}>
                  <Plus className="h-4 w-4" />
                  Novo Banco
                </Button>
              )}
            </div>

            {/* Linha 2: Abas de filtro */}
            <div className="flex flex-wrap gap-1 p-1 bg-slate-100 rounded-lg">
              <Button
                variant={filtroCaracteristica === "todos" ? "default" : "ghost"}
                size="sm"
                onClick={() => setFiltroCaracteristica("todos")}
                className="text-xs"
              >
                Todos ({bancos.length})
              </Button>
              <Button
                variant={filtroCaracteristica === "parceiro" ? "default" : "ghost"}
                size="sm"
                onClick={() => setFiltroCaracteristica("parceiro")}
                className="text-xs"
              >
                Parceiro ({contarPorCaracteristica("parceiro")})
              </Button>
              <Button
                variant={filtroCaracteristica === "linkacesso" ? "default" : "ghost"}
                size="sm"
                onClick={() => setFiltroCaracteristica("linkacesso")}
                className="text-xs gap-1"
                data-testid="tab-link-acesso"
              >
                <KeyRound className="h-3 w-3" />
                LINK ACESSO ({bancos.filter(temAcessos).length})
              </Button>
              <Button
                variant={filtroCaracteristica === "instituicoes" ? "default" : "ghost"}
                size="sm"
                onClick={() => setFiltroCaracteristica("instituicoes")}
                className="text-xs gap-1"
                data-testid="tab-instituicoes"
              >
                <Landmark className="h-3 w-3" />
                Instituições ({instAcessoList.length})
              </Button>
            </div>
          </div>

          {/* Painel LINK ACESSO, Instituições, ou Tabela de bancos */}
          {filtroCaracteristica === "linkacesso" ? (
            <div className="overflow-y-auto max-h-[calc(100vh-320px)] min-h-[400px] border rounded-lg divide-y" data-testid="link-acesso-grid">
              {filtrarBancos().filter(temAcessos).length === 0 ? (
                <div className="p-10 text-center text-sm text-muted-foreground">Nenhum banco com acessos ao portal encontrado.</div>
              ) : (
                filtrarBancos().filter(temAcessos).map((banco) => (
                  <div key={banco.id} className="p-3 hover:bg-slate-50" data-testid={`acesso-banco-${banco.id}`}>
                    <div className="flex items-center gap-3 mb-2">
                      {banco.logo ? (
                        <img src={banco.logo} alt={banco.nome} className="h-8 w-16 object-contain rounded border bg-white" />
                      ) : (
                        <div className="h-8 w-16 rounded border bg-slate-100 flex items-center justify-center text-[9px] text-slate-400">sem logo</div>
                      )}
                      <div className="font-mono text-xs text-slate-500 w-14">{banco.codigo || "-"}</div>
                      <div className="font-semibold text-sm text-blue-700">{banco.nome}</div>
                    </div>
                    <div className="space-y-2 md:pl-[76px]">
                      {(banco.acessos || []).filter(a => a && (a.link || a.usuario || a.correspondente || a.senha)).map((ac, idx) => {
                        const chave = `${banco.id}_${idx}`;
                        return (
                          <div key={chave} className="grid grid-cols-1 md:grid-cols-[150px_1fr_170px_180px] gap-2 md:items-center bg-white border rounded-md p-2" data-testid={`acesso-row-${banco.id}-${idx}`}>
                            <div className="text-xs min-w-0"><span className="text-slate-400">Correspondente</span><br /><span className="font-medium">{ac.correspondente || "-"}</span></div>
                            <div className="text-xs min-w-0"><span className="text-slate-400">Link de acesso</span>
                              <div className="flex items-center gap-1">
                                <span className="truncate text-slate-700" title={ac.link}>{ac.link || "-"}</span>
                                {ac.link && (
                                  <Button variant="outline" size="sm" className="h-6 px-2 shrink-0" data-testid={`btn-abrir-link-${banco.id}-${idx}`} onClick={() => abrirLinkAcesso(ac.link)} title="Abrir portal">
                                    <ExternalLink className="h-3 w-3" />
                                  </Button>
                                )}
                              </div>
                            </div>
                            <div className="text-xs min-w-0"><span className="text-slate-400">Usuário</span>
                              <div className="flex items-center gap-1">
                                <span className="font-mono truncate" title={ac.usuario}>{ac.usuario || "-"}</span>
                                {ac.usuario && (
                                  <Button variant="ghost" size="sm" className="h-6 w-6 p-0 shrink-0" onClick={() => copiarTexto(ac.usuario)} title="Copiar usuário"><Copy className="h-3 w-3" /></Button>
                                )}
                              </div>
                            </div>
                            <div className="text-xs min-w-0"><span className="text-slate-400">Senha</span>
                              <div className="flex items-center gap-1">
                                <span className="font-mono truncate">{showSenhaAcesso[chave] ? (ac.senha || "-") : "••••••••"}</span>
                                <Button variant="ghost" size="sm" className="h-6 w-6 p-0 shrink-0" data-testid={`btn-ver-senha-${banco.id}-${idx}`} onClick={() => setShowSenhaAcesso(prev => ({ ...prev, [chave]: !prev[chave] }))} title="Ver senha">
                                  {showSenhaAcesso[chave] ? <EyeOff className="h-3 w-3" /> : <Eye className="h-3 w-3" />}
                                </Button>
                                {ac.senha && (
                                  <Button variant="ghost" size="sm" className="h-6 w-6 p-0 shrink-0" onClick={() => copiarTexto(ac.senha)} title="Copiar senha"><Copy className="h-3 w-3" /></Button>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))
              )}
            </div>
          ) : filtroCaracteristica === "instituicoes" ? (
            /* ========== PAINEL INSTITUIÇÕES ========== */
            <div className="overflow-y-auto max-h-[calc(100vh-320px)] min-h-[400px] border rounded-lg divide-y" data-testid="instituicoes-grid">
              {filtrarInstAcesso().length === 0 ? (
                <div className="p-10 text-center text-sm text-muted-foreground">
                  {instAcessoList.length === 0
                    ? "Nenhuma instituição cadastrada. Clique em \"+ Nova Instituição\" para adicionar."
                    : "Nenhuma instituição encontrada para esta busca."}
                </div>
              ) : (
                filtrarInstAcesso().map((inst) => (
                  <div key={inst.id} className="p-3 hover:bg-slate-50" data-testid={`inst-row-${inst.id}`}>
                    <div className="flex items-center gap-3 mb-2">
                      <div className="h-8 w-8 rounded-md bg-emerald-100 border border-emerald-200 flex items-center justify-center">
                        <Landmark className="h-4 w-4 text-emerald-700" />
                      </div>
                      <div className="font-semibold text-sm text-emerald-800 flex-1">{inst.nome}</div>
                      <Button variant="ghost" size="sm" className="h-7 px-2 text-xs text-slate-500 hover:text-blue-600" onClick={() => abrirEditarInstAcesso(inst)} data-testid={`btn-editar-inst-${inst.id}`}>
                        <Edit className="h-3 w-3 mr-1" /> Editar
                      </Button>
                      <Button variant="ghost" size="sm" className="h-7 px-2 text-xs text-slate-500 hover:text-red-600" onClick={() => excluirInstAcesso(inst)} data-testid={`btn-excluir-inst-${inst.id}`}>
                        <Trash2 className="h-3 w-3" />
                      </Button>
                    </div>
                    <div className="md:pl-11">
                      <div className="grid grid-cols-1 md:grid-cols-[1fr_200px_200px] gap-2 md:items-center bg-white border rounded-md p-2">
                        <div className="text-xs min-w-0"><span className="text-slate-400">Link de acesso</span>
                          <div className="flex items-center gap-1">
                            <span className="truncate text-slate-700" title={inst.url}>{inst.url || "-"}</span>
                            {inst.url && (
                              <Button variant="outline" size="sm" className="h-6 px-2 shrink-0" onClick={() => abrirLinkAcesso(inst.url)} title="Abrir portal" data-testid={`btn-abrir-inst-${inst.id}`}>
                                <ExternalLink className="h-3 w-3" />
                              </Button>
                            )}
                          </div>
                        </div>
                        <div className="text-xs min-w-0"><span className="text-slate-400">Usuário</span>
                          <div className="flex items-center gap-1">
                            <span className="font-mono truncate" title={inst.usuario}>{inst.usuario || "-"}</span>
                            {inst.usuario && (
                              <Button variant="ghost" size="sm" className="h-6 w-6 p-0 shrink-0" onClick={() => copiarTexto(inst.usuario)} title="Copiar usuário"><Copy className="h-3 w-3" /></Button>
                            )}
                          </div>
                        </div>
                        <div className="text-xs min-w-0"><span className="text-slate-400">Senha</span>
                          <div className="flex items-center gap-1">
                            <span className="font-mono truncate">{showSenhaInst[inst.id] ? (inst.senha || "-") : "••••••••"}</span>
                            <Button variant="ghost" size="sm" className="h-6 w-6 p-0 shrink-0" onClick={() => setShowSenhaInst(prev => ({ ...prev, [inst.id]: !prev[inst.id] }))} title="Ver senha" data-testid={`btn-ver-senha-inst-${inst.id}`}>
                              {showSenhaInst[inst.id] ? <EyeOff className="h-3 w-3" /> : <Eye className="h-3 w-3" />}
                            </Button>
                            {inst.senha && (
                              <Button variant="ghost" size="sm" className="h-6 w-6 p-0 shrink-0" onClick={() => copiarTexto(inst.senha)} title="Copiar senha"><Copy className="h-3 w-3" /></Button>
                            )}
                          </div>
                        </div>
                      </div>
                      {inst.observacoes && (
                        <div className="text-xs text-slate-500 mt-1 italic">{inst.observacoes}</div>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>
          ) : (
          <div className="overflow-x-auto max-h-[calc(100vh-320px)] min-h-[400px] overflow-y-auto border rounded-lg">
            <Table>
              <TableHeader className="sticky top-0 bg-white z-10">
                <TableRow className="bg-slate-100">
                  <TableHead className="font-bold">Código</TableHead>
                  <TableHead className="font-bold">Nome do Banco</TableHead>
                  <TableHead className="font-bold min-w-[180px]">Instituições</TableHead>
                  <TableHead className="text-center font-bold">Parceiro</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {filtrarBancos().map((banco) => (
                      <TableRow key={banco.id} className="hover:bg-slate-50">
                        <TableCell className="font-mono font-bold">{banco.codigo}</TableCell>
                        <TableCell 
                          className="font-semibold text-sm text-blue-600 hover:text-blue-800 cursor-pointer hover:underline"
                          onClick={() => navigate(`/bancos/${banco.id}/editar`)}
                        >
                          {banco.nome}
                        </TableCell>
                        {/* Coluna de Instituições */}
                        <TableCell className="min-w-[180px]">
                          <div className="flex flex-wrap gap-1 items-center">
                            {(banco.instituicoes || []).slice(0, 3).map(instCodigo => (
                              <Badge 
                                key={instCodigo} 
                                variant="outline" 
                                className="text-[10px] bg-blue-50 text-blue-700 border-blue-200"
                              >
                                {getNomeInstituicao(instCodigo)}
                              </Badge>
                            ))}
                            {(banco.instituicoes || []).length > 3 && (
                              <Badge variant="outline" className="text-[10px]">
                                +{(banco.instituicoes || []).length - 3}
                              </Badge>
                            )}
                            <Button
                              variant="ghost"
                              size="sm"
                              className="h-6 w-6 p-0 hover:bg-blue-50"
                              onClick={() => abrirModalInstituicoes(banco)}
                              title="Gerenciar instituições"
                            >
                              <Plus className="h-3 w-3 text-blue-600" />
                            </Button>
                          </div>
                        </TableCell>
                        <TableCell className="text-center">
                          <Checkbox 
                            checked={banco.parceiro} 
                            onCheckedChange={() => toggleBancoCheckbox(banco.id, 'parceiro')}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
          )}
            </CardContent>
          </Card>

      {/* Dialog de Confirmação de Exclusão */}
      <Dialog open={deleteDialogOpen} onOpenChange={setDeleteDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="text-red-600">Confirmar Exclusão</DialogTitle>
            <DialogDescription>
              Tem certeza que deseja excluir este item? Esta ação não pode ser desfeita.
            </DialogDescription>
          </DialogHeader>
          {itemToDelete && (
            <div className="py-4">
              <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
                <p className="font-semibold text-red-800">
                  {deleteModule === 'bancos' ? `${itemToDelete.codigo} - ${itemToDelete.nome}` : 
                   deleteModule === 'regras' ? `${itemToDelete.regra}: ${itemToDelete.valor}` :
                   itemToDelete.banco || itemToDelete.tipo || 'Item selecionado'}
                </p>
              </div>
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setDeleteDialogOpen(false)}>
              Cancelar
            </Button>
            <Button variant="destructive" onClick={excluirItem}>
              <Trash2 className="h-4 w-4 mr-2" />
              Excluir
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog de Edição de Banco */}
      <Dialog open={editBancoDialogOpen} onOpenChange={setEditBancoDialogOpen}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle className="text-blue-800 flex items-center gap-2">
              <Edit className="h-5 w-5" />
              Editar Banco
            </DialogTitle>
            <DialogDescription>
              Edite as informações do banco selecionado
            </DialogDescription>
          </DialogHeader>
          
          {bancoEditando && (
            <div className="space-y-6 py-4">
              {/* Informações Básicas */}
              <div className="grid gap-4 grid-cols-2">
                <div>
                  <Label className="text-sm font-semibold">Código</Label>
                  <Input
                    value={bancoEditando.codigo}
                    onChange={(e) => setBancoEditando({...bancoEditando, codigo: e.target.value})}
                    className="mt-1"
                    placeholder="000"
                  />
                </div>
                <div>
                  <Label className="text-sm font-semibold">Nome do Banco</Label>
                  <Input
                    value={bancoEditando.nome}
                    onChange={(e) => setBancoEditando({...bancoEditando, nome: e.target.value})}
                    className="mt-1"
                    placeholder="Nome do banco"
                  />
                </div>
              </div>

              {/* Checkboxes de Funcionalidades */}
              <div>
                <Label className="text-sm font-semibold mb-3 block">Funcionalidades Habilitadas</Label>
                <div className="grid grid-cols-4 gap-4 p-4 bg-slate-50 rounded-lg">
                  <div className="flex items-center space-x-2">
                    <Checkbox 
                      id="edit-parceiro"
                      checked={bancoEditando.parceiro}
                      onCheckedChange={(checked) => setBancoEditando({...bancoEditando, parceiro: checked})}
                    />
                    <Label htmlFor="edit-parceiro" className="text-sm cursor-pointer">Parceiro</Label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Checkbox 
                      id="edit-consignado"
                      checked={bancoEditando.consignado}
                      onCheckedChange={(checked) => setBancoEditando({...bancoEditando, consignado: checked})}
                    />
                    <Label htmlFor="edit-consignado" className="text-sm cursor-pointer">Consignado</Label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Checkbox 
                      id="edit-srt"
                      checked={bancoEditando.srt}
                      onCheckedChange={(checked) => setBancoEditando({...bancoEditando, srt: checked})}
                    />
                    <Label htmlFor="edit-srt" className="text-sm cursor-pointer">SRT</Label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Checkbox 
                      id="edit-seguro"
                      checked={bancoEditando.seguro}
                      onCheckedChange={(checked) => setBancoEditando({...bancoEditando, seguro: checked})}
                    />
                    <Label htmlFor="edit-seguro" className="text-sm cursor-pointer">Seguro</Label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Checkbox 
                      id="edit-cartao"
                      checked={bancoEditando.cartao}
                      onCheckedChange={(checked) => setBancoEditando({...bancoEditando, cartao: checked})}
                    />
                    <Label htmlFor="edit-cartao" className="text-sm cursor-pointer">Cartão</Label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Checkbox 
                      id="edit-refin"
                      checked={bancoEditando.refin}
                      onCheckedChange={(checked) => setBancoEditando({...bancoEditando, refin: checked})}
                    />
                    <Label htmlFor="edit-refin" className="text-sm cursor-pointer">Refin</Label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Checkbox 
                      id="edit-portabilidade"
                      checked={bancoEditando.portabilidade}
                      onCheckedChange={(checked) => setBancoEditando({...bancoEditando, portabilidade: checked})}
                    />
                    <Label htmlFor="edit-portabilidade" className="text-sm cursor-pointer">Portabilidade</Label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Checkbox 
                      id="edit-esteira"
                      checked={bancoEditando.esteira}
                      onCheckedChange={(checked) => setBancoEditando({...bancoEditando, esteira: checked})}
                    />
                    <Label htmlFor="edit-esteira" className="text-sm cursor-pointer">Esteira</Label>
                  </div>
                </div>
              </div>
            </div>
          )}
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setEditBancoDialogOpen(false)}>
              Cancelar
            </Button>
            <Button onClick={salvarEdicaoBanco} className="bg-blue-600 hover:bg-blue-700">
              <Save className="h-4 w-4 mr-2" />
              Salvar Alterações
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal de Gerenciamento de Instituições */}
      <Dialog open={instituicoesDialogOpen} onOpenChange={setInstituicoesDialogOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Landmark className="h-5 w-5 text-blue-600" />
              Instituições - {bancoSelecionadoInst?.nome}
            </DialogTitle>
            <DialogDescription>
              Gerencie quais instituições este banco trabalha
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 py-4">
            {/* Instituições Vinculadas */}
            <div>
              <Label className="text-sm font-semibold mb-2 block">
                Instituições Vinculadas ({instituicoesVinculadas.length})
              </Label>
              {instituicoesVinculadas.length === 0 ? (
                <div className="p-4 bg-slate-50 rounded-lg text-center text-sm text-slate-500">
                  Nenhuma instituição vinculada. Adicione abaixo.
                </div>
              ) : (
                <div className="flex flex-wrap gap-2 p-3 bg-slate-50 rounded-lg min-h-[60px]">
                  {instituicoesVinculadas.map(instCodigo => (
                    <Badge 
                      key={instCodigo} 
                      className="bg-blue-100 text-blue-800 border-blue-300 flex items-center gap-1 pr-1"
                    >
                      {getNomeInstituicao(instCodigo)}
                      <button
                        onClick={() => removerInstituicao(instCodigo)}
                        className="ml-1 hover:bg-blue-200 rounded-full p-0.5"
                        disabled={loadingInstituicoes}
                      >
                        <X className="h-3 w-3" />
                      </button>
                    </Badge>
                  ))}
                </div>
              )}
            </div>

            {/* Adicionar Instituição */}
            <div>
              <Label className="text-sm font-semibold mb-2 block">
                Adicionar Instituição
              </Label>
              <ScrollArea className="h-[200px] border rounded-lg p-2">
                <div className="space-y-1">
                  {todasInstituicoes
                    .filter(inst => !instituicoesVinculadas.includes(inst.codigo))
                    .map(inst => (
                      <div 
                        key={inst.codigo}
                        className="flex items-center justify-between p-2 hover:bg-slate-50 rounded cursor-pointer group"
                        onClick={() => adicionarInstituicao(inst.codigo)}
                      >
                        <span className="text-sm">
                          <span className="font-mono text-slate-500 mr-2">{inst.codigo}</span>
                          {inst.nome}
                        </span>
                        <Button 
                          variant="ghost" 
                          size="sm" 
                          className="h-6 opacity-0 group-hover:opacity-100 transition-opacity"
                          disabled={loadingInstituicoes}
                        >
                          <Plus className="h-3 w-3 mr-1" />
                          Adicionar
                        </Button>
                      </div>
                    ))}
                  {todasInstituicoes.filter(inst => !instituicoesVinculadas.includes(inst.codigo)).length === 0 && (
                    <div className="text-center text-sm text-slate-500 py-4">
                      Todas as instituições já foram vinculadas
                    </div>
                  )}
                </div>
              </ScrollArea>
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setInstituicoesDialogOpen(false)}>
              Fechar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog de Criar/Editar Instituição Acesso */}
      <Dialog open={instAcessoDialogOpen} onOpenChange={setInstAcessoDialogOpen}>
        <DialogContent className="max-w-lg" data-testid="dialog-inst-acesso">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-emerald-800">
              <Landmark className="h-5 w-5" />
              {instAcessoEditando ? "Editar Instituição" : "Nova Instituição"}
            </DialogTitle>
            <DialogDescription>
              Cadastre os dados de acesso ao portal do órgão ou convênio
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 py-2">
            <div>
              <Label className="text-sm font-semibold">Nome da Instituição *</Label>
              <Input
                value={instAcessoForm.nome}
                onChange={(e) => setInstAcessoForm(f => ({ ...f, nome: e.target.value }))}
                placeholder="Ex: INSS, SIAPE, Prefeitura de..."
                className="mt-1"
                data-testid="input-inst-nome"
              />
            </div>
            <div>
              <Label className="text-sm font-semibold">URL de Acesso</Label>
              <Input
                value={instAcessoForm.url}
                onChange={(e) => setInstAcessoForm(f => ({ ...f, url: e.target.value }))}
                placeholder="https://portal.exemplo.gov.br"
                className="mt-1"
                data-testid="input-inst-url"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-sm font-semibold">Usuário</Label>
                <Input
                  value={instAcessoForm.usuario}
                  onChange={(e) => setInstAcessoForm(f => ({ ...f, usuario: e.target.value }))}
                  placeholder="login"
                  className="mt-1"
                  data-testid="input-inst-usuario"
                />
              </div>
              <div>
                <Label className="text-sm font-semibold">Senha</Label>
                <Input
                  value={instAcessoForm.senha}
                  onChange={(e) => setInstAcessoForm(f => ({ ...f, senha: e.target.value }))}
                  placeholder="senha"
                  className="mt-1"
                  data-testid="input-inst-senha"
                />
              </div>
            </div>
            <div>
              <Label className="text-sm font-semibold">Observações</Label>
              <Input
                value={instAcessoForm.observacoes}
                onChange={(e) => setInstAcessoForm(f => ({ ...f, observacoes: e.target.value }))}
                placeholder="Observações opcionais"
                className="mt-1"
                data-testid="input-inst-obs"
              />
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setInstAcessoDialogOpen(false)}>
              Cancelar
            </Button>
            <Button onClick={salvarInstAcesso} className="bg-emerald-600 hover:bg-emerald-700" disabled={loadingInstAcesso} data-testid="btn-salvar-inst">
              {loadingInstAcesso ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Save className="h-4 w-4 mr-2" />}
              {instAcessoEditando ? "Salvar Alterações" : "Cadastrar"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
